<div [formGroup]="form">
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-12">
            <div class="permit-washers-wrapper">
                <mat-label
                    class="card-title text-dark mt-4 mb-4 font-14 font-400 permit-label"
                    style="line-height: 18px"
                    placement="right"
                    container="body"
                    [ngbTooltip]="breakout_tooltip"
                    tooltipClass="custom-tooltip"
                    tooltipClass="custom-tooltip"
                >
                    {{ 'SETTING_PAGE.IDMS_SETTINGS.PERMIT_WASHERS' | transloco }}
                </mat-label>

                <ng-template #breakout_tooltip>
                    <p>
                        {{ 'TOOLTIP.INFORMATE_CALC_LABELS.BREAKOUT' | transloco }}
                    </p>
                </ng-template>

                <mat-checkbox class="permit-checkbox example-margin checkbox-wrap" formControlName="permitWashers" name="permitWashers"></mat-checkbox>
            </div>
        </div>
    </div>
</div>
